import { getProductsSerials } from "../../products/functions";
import { getSerialsByNumbers } from "../functions";
import { getExtendedArtOrder, getExtendedArtSerialsByNumbers } from "../../extendedArt/functions";
import { mergeResolvedSerials } from "./resolveTagsSelection";
import { splitBlockedExtended } from "./extendedCards";

const fail = (message) => {
  throw new Error(message);
};

/**
 * Resolve a seleção do gerador nas duas fontes (spec §5.4):
 * - pedidos comuns → POST /admin/serials/products;
 * - pedidos estendidos → GET /admin/extended-art/orders/:id (só seriais finais);
 * - números digitados → lookup comum; os ausentes vão ao by-numbers estendido
 *   (o prefixo do número é do backend; o admin não o duplica).
 */
export async function resolveTagSources({ token, productIds = [], extendedOrderIds = [], serialNumbers = [] }) {
  let fromProducts = [];
  if (productIds.length) {
    const data = await getProductsSerials(token, productIds);
    if (data?.type !== "success") fail(data?.message || "Erro ao buscar seriais dos pedidos");
    fromProducts = data.data || [];
  }

  let fromLookup = { found: [], missing: [] };
  if (serialNumbers.length) {
    const data = await getSerialsByNumbers(token, serialNumbers);
    if (data?.type !== "success") fail(data?.message || "Erro no lookup de seriais");
    fromLookup = { found: data.found || [], missing: data.missing || [] };
  }
  const { serials, missing: missingCommon } = mergeResolvedSerials({ fromProducts, fromLookup });

  const extended = new Map();
  for (const orderId of extendedOrderIds) {
    const data = await getExtendedArtOrder(token, orderId);
    if (data?.type !== "success") fail(data?.message || "Erro ao buscar o pedido de arte estendida");
    for (const serial of data.data?.serials || []) {
      if (!serial.isDraft && serial.serialNumber) extended.set(serial.serialNumber, serial);
    }
  }

  let missing = missingCommon;
  if (missingCommon.length) {
    const data = await getExtendedArtSerialsByNumbers(token, missingCommon);
    if (data?.type !== "success") fail(data?.message || "Erro no lookup de seriais de arte estendida");
    for (const serial of data.data || []) {
      if (serial?.serialNumber) extended.set(serial.serialNumber, serial);
    }
    missing = missingCommon.filter((number) => !extended.has(number));
  }

  return { serials, extendedSerials: [...extended.values()], missing };
}

/**
 * Carrega a seleção e já separa os estendidos liberados dos bloqueados
 * (flag desligada, mobile, arte não aprovada ou indisponível). Compartilhado
 * pelos geradores desktop e mobile.
 */
export async function resolveAndSplit(picked, { token, artEnabled, mobile }) {
  const { serials, extendedSerials, missing } = await resolveTagSources({ token, ...picked });
  const { allowed, blocked } = splitBlockedExtended(extendedSerials, { artEnabled, mobile });
  return { serials, allowedExtended: allowed, blocked, missing };
}
